import confetti from "canvas-confetti";

/**
 * Client-conversion celebration — fires when a client/referrer successfully
 * submits an "Instruct" request. Three small touches in one helper:
 *
 *   1. Short haptic buzz (mobile only; silently no-op on desktop).
 *   2. Brand-coloured confetti burst from the bottom-centre (where the sticky
 *      CTA sits on mobile — keeps the origin visually tied to the tap).
 *   3. Smooth-scroll to the confirmation target once rendered, so the client
 *      immediately sees the "Instruction Received" badge / success state.
 *
 * Accepts an optional testid to scroll into view after a short delay (lets
 * React finish the state update first). No-ops safely if the element doesn't
 * exist yet.
 */
export function celebrateInstruction(scrollToTestId) {
  // 1. Haptic feedback — 12ms → 40ms → 12ms pattern feels like a tiny tap-buzz
  //    (Safari/iOS is still strict about requiring user gesture; this runs in
  //    the click handler path so it works on supported devices).
  try {
    if (navigator.vibrate) navigator.vibrate([12, 40, 12]);
  } catch {
    /* ignore — unsupported browsers */
  }

  // 2. Confetti burst — brand colours from UKC Legal guidelines.
  const defaults = {
    particleCount: 70,
    spread: 55,
    startVelocity: 45,
    gravity: 0.95,
    ticks: 200,
    scalar: 0.9,
    colors: ["#100f5d", "#c87d3a", "#e89e63", "#10b981", "#ffffff"],
    disableForReducedMotion: true,
  };
  try {
    confetti({ ...defaults, origin: { x: 0.3, y: 1.05 } });
    setTimeout(() => confetti({ ...defaults, origin: { x: 0.7, y: 1.05 } }), 120);
  } catch {
    /* ignore — canvas unsupported */
  }

  // 3. Scroll to the confirmation target after the UI has rendered it.
  if (scrollToTestId) {
    setTimeout(() => {
      const el = document.querySelector(`[data-testid="${scrollToTestId}"]`);
      if (el && "scrollIntoView" in el) {
        el.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }, 250);
  }
}
